import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CurrenciesLayer from "../components/CurrenciesLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const CurrenciesPage = () => {
  const hasPermission = usePermission("currencies", "view");

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Currency" header="Currency" />

        {/* CurrenciesLayer */}
        {hasPermission ? <CurrenciesLayer /> : <AccessDeniedLayer />}


      </MasterLayout>
    </>
  );
};

export default CurrenciesPage;
